import React from 'react'
import { Outlet } from 'react-router-dom'
import MainNavigation from '../components/MainNavigation'
import Header from '../components/Header'
import Footer from '../components/Footer'
import toast, { Toaster } from 'react-hot-toast';
const Main = () => {
    return (
        <>
            <Header/>
            <MainNavigation/>

            <Outlet/>
            <Footer/>  
             <Toaster position="bottom-left" reverseOrder={false}  toastOptions={{
    style: {
      fontSize: "18px",
      padding: "16px",
      background:""
    },
  }} />
          
        </>
    )
}

export default Main